import { usePreloadNeon } from './hooks';
import { StaffRoutes } from './routes/staff-routes';

export function AppStaff() {
  usePreloadNeon();
  return <StaffRoutes />;
}
